/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/SheetForecast', 'model/SheetForecastReport'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/SheetForecast'), require('../model/SheetForecastReport'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.SheetForecastApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.SheetForecast, root.ForStractionServiceApi.SheetForecastReport);
  }
}(this, function(ApiClient, SheetForecast, SheetForecastReport) {
  'use strict';

  /**
   * SheetForecast service.
   * @module api/SheetForecastApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new SheetForecastApi. 
   * @alias module:api/SheetForecastApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the sheetForecastAddPut operation.
     * @callback module:api/SheetForecastApi~sheetForecastAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/SheetForecast} body 
     * @param {module:api/SheetForecastApi~sheetForecastAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.sheetForecastAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sheetForecastAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling sheetForecastAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/SheetForecast/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sheetForecastAggregateFileHierarchyGet operation.
     * @callback module:api/SheetForecastApi~sheetForecastAggregateFileHierarchyGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * aggregateFileHierarchy
     * @param {String} _4SAPIAppID 
     * @param {Integer} forecastID 
     * @param {module:api/SheetForecastApi~sheetForecastAggregateFileHierarchyGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.sheetForecastAggregateFileHierarchyGet = function(_4SAPIAppID, forecastID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sheetForecastAggregateFileHierarchyGet";
      }

      // verify the required parameter 'forecastID' is set
      if (forecastID == undefined || forecastID == null) {
        throw "Missing the required parameter 'forecastID' when calling sheetForecastAggregateFileHierarchyGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'forecastID': forecastID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/SheetForecast/aggregateFileHierarchy', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sheetForecastAggregateTopParentGet operation.
     * @callback module:api/SheetForecastApi~sheetForecastAggregateTopParentGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * aggregateTopParent
     * @param {String} _4SAPIAppID 
     * @param {Integer} forecastID 
     * @param {module:api/SheetForecastApi~sheetForecastAggregateTopParentGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.sheetForecastAggregateTopParentGet = function(_4SAPIAppID, forecastID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sheetForecastAggregateTopParentGet";
      }

      // verify the required parameter 'forecastID' is set
      if (forecastID == undefined || forecastID == null) {
        throw "Missing the required parameter 'forecastID' when calling sheetForecastAggregateTopParentGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'forecastID': forecastID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/SheetForecast/aggregateTopParent', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sheetForecastDeleteGet operation.
     * @callback module:api/SheetForecastApi~sheetForecastDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} forecastID 
     * @param {module:api/SheetForecastApi~sheetForecastDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.sheetForecastDeleteGet = function(_4SAPIAppID, forecastID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sheetForecastDeleteGet";
      }

      // verify the required parameter 'forecastID' is set
      if (forecastID == undefined || forecastID == null) {
        throw "Missing the required parameter 'forecastID' when calling sheetForecastDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'forecastID': forecastID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/SheetForecast/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sheetForecastEditPut operation.
     * @callback module:api/SheetForecastApi~sheetForecastEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/SheetForecast} body 
     * @param {module:api/SheetForecastApi~sheetForecastEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.sheetForecastEditPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sheetForecastEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling sheetForecastEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/SheetForecast/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sheetForecastLoadAllGet operation.
     * @callback module:api/SheetForecastApi~sheetForecastLoadAllGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/SheetForecastReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadAll
     * @param {String} _4SAPIAppID 
     * @param {module:api/SheetForecastApi~sheetForecastLoadAllGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/SheetForecastReport>}
     */
    this.sheetForecastLoadAllGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sheetForecastLoadAllGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [SheetForecastReport];

      return this.apiClient.callApi(
        '/SheetForecast/loadAll', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sheetForecastLoadGet operation.
     * @callback module:api/SheetForecastApi~sheetForecastLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SheetForecastReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {Integer} forecastID 
     * @param {module:api/SheetForecastApi~sheetForecastLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SheetForecastReport}
     */
    this.sheetForecastLoadGet = function(_4SAPIAppID, forecastID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sheetForecastLoadGet";
      }

      // verify the required parameter 'forecastID' is set
      if (forecastID == undefined || forecastID == null) {
        throw "Missing the required parameter 'forecastID' when calling sheetForecastLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'forecastID': forecastID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = SheetForecastReport;

      return this.apiClient.callApi(
        '/SheetForecast/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
